import React from 'react';
import { reportError } from '../lib/errorReporter';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    reportError({
      message: error && error.message,
      stack: (error && error.stack) || (info && info.componentStack),
      error_type: (error && error.name) || 'ReactError',
      context: { componentStack: info && info.componentStack },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: 24, textAlign: 'center', fontFamily: 'system-ui' }}>
            <h2>Something went wrong.</h2>
            <p style={{ color: '#888' }}>The error has been reported. Try reloading.</p>
            <button
              onClick={() => window.location.reload()}
              style={{ marginTop: 12, padding: '8px 16px', borderRadius: 8, cursor: 'pointer' }}
            >
              Reload
            </button>
          </div>
        )
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
